/**
 * Shared Food Safety page chrome — light consistency with Home (19.28 / 19.30).
 * OMS lime/olive/mayo; no Success Hub Progress restyle.
 */

import styled from 'styled-components/macro'
import { H1 } from 'src/branding/typography'
import { FOOD_SAFETY_SURFACE } from 'src/constants/foodSafety'

/** Soft lime hero band behind section / Reports titles (+ day nav). */
export const FoodSafetyHeroBand = styled.section`
  margin: 0 0 ${({ theme }) => theme.spacing.md};
  padding: ${({ theme }) => theme.spacing.md};
  border: 1px solid ${FOOD_SAFETY_SURFACE.HERO_BORDER};
  border-radius: ${FOOD_SAFETY_SURFACE.CARD_RADIUS};
  background: ${FOOD_SAFETY_SURFACE.HERO_BG};
  box-shadow: ${FOOD_SAFETY_SURFACE.CARD_SHADOW};
  border-top: 3px solid
    ${({ theme }) => theme.colours.lettuceGreen || '#b5d922'};
  min-width: 0;
`

/** Title + day nav (or actions) inside the hero band. */
export const FoodSafetyHeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  min-width: 0;

  ${({ theme }) => theme.device('md')`
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  `};
`

export const FoodSafetyPageTitle = styled(H1)`
  margin: 0;
  font-size: 1.75rem;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colours.bbqBlack || '#000'};

  ${({ theme }) => theme.device('md')`
    font-size: 2rem;
  `};
`

/** Composer / unit cards / report panels. */
export const FoodSafetySurfaceCard = styled.div`
  background: ${({ theme }) => theme.colours.mayoWhite || '#fff'};
  border: 1px solid ${FOOD_SAFETY_SURFACE.HERO_BORDER};
  border-radius: ${FOOD_SAFETY_SURFACE.CARD_RADIUS};
  box-shadow: ${FOOD_SAFETY_SURFACE.CARD_SHADOW};
  padding: ${({ theme }) => theme.spacing.sm};
  min-width: 0;

  ${({ theme }) => theme.device('md')`
    padding: ${theme.spacing.md};
  `};

  &[data-accent='lime'] {
    border-color: ${FOOD_SAFETY_SURFACE.LIME_EDGE};
    border-left: 3px solid
      ${({ theme }) => theme.colours.lettuceGreen || '#b5d922'};
  }

  &[data-next='true'] {
    border-color: ${({ theme }) => theme.colours.lettuceGreen || '#7cb305'};
    box-shadow: ${FOOD_SAFETY_SURFACE.CARD_SHADOW_HOVER};
  }
`

/** Inline failed-submit strip (29.37 / 29.66) — loud mid-round, not button-only. */
export const FoodSafetySubmitErrorBox = styled.div`
  margin: ${({ theme }) => theme.spacing.xs || '0.5rem'} 0;
  padding: 0.7rem 0.85rem;
  border-radius: ${FOOD_SAFETY_SURFACE.CARD_RADIUS};
  background: #fff2e8;
  border: 1px solid #f5d0b5;
  border-left: 3px solid ${FOOD_SAFETY_SURFACE.STATUS_ATTENTION};
  color: ${FOOD_SAFETY_SURFACE.STATUS_ATTENTION};
  font-size: 0.875rem;
  line-height: 1.35;
`

export const FoodSafetySubmitErrorLead = styled.div`
  font-weight: 700;
  margin-bottom: 0.2rem;
`
